import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button", "content"]

  toggle() {
    if (!this.hasMenuTarget) return
    
    this.menuTarget.classList.toggle("hidden")
    const isExpanded = !this.menuTarget.classList.contains("hidden")
    
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", isExpanded)
    }
    
    // Prevent body scroll when menu is open
    if (isExpanded) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }

  close() {
    if (!this.hasMenuTarget) return
    
    this.menuTarget.classList.add("hidden")
    
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
    
    document.body.style.overflow = ""
  }

  // Close menu when clicking outside
  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
    document.body.style.overflow = ""
  }

  handleClickOutside(event) {
    if (!this.hasMenuTarget || this.menuTarget.classList.contains("hidden")) return
    
    // Check if click is outside the menu content and button
    if (!this.contentTarget.contains(event.target) && 
        !this.buttonTarget.contains(event.target)) {
      this.close()
    }
  }
}
